import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 50px;
`;
